import { Validators } from '@angular/forms';
import { QaroniBaseFormsDirective } from '@qaroni-core/directives/qaroni-base-forms/qaroni-base-forms.directive';

export class AssessmentResultsCommentsRegisterForm extends QaroniBaseFormsDirective {
  public skeleton = {
    commentId: [null],
    message: ['', Validators.required],
    employeeId: [null, Validators.required],
    ownerId: [null],
  };

  public form = this.fb.group(this.skeleton);

  get message() {
    return this.form.get('message');
  }

  get employeeId() {
    return this.form.get('employeeId');
  }

  get commentId() {
    return this.form.get('commentId');
  }

  get ownerId() {
    return this.form.get('ownerId');
  }
}
